import { Component, OnInit, OnDestroy, Inject, ViewChild } from '@angular/core';
import { Store, Action } from '@ngrx/store';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { MatDialogRef } from "@angular/material";
import { Actions } from '@ngrx/effects';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material';
import * as actions from '../../pillar/dashboard/store/actions';
import { ModuleConfiguration as SubmissionModuleConfiguration} from "../submission.module.config";
import { DeleteSubmittingEntityModel } from "../models/DeleteSubmittingEntityModel";
import * as dashboardActions from '../../pillar/dashboard/store/actions';
import * as fromStore from '../store/reducers';
import { SubmittingEntityListModel } from '../models/SubmittingEntityListModel';
import { SubmittingEntityModel } from '../models/SubmittingEntityModel';
import { TileState } from '../../pillar/dashboard/store/state/TileState';
import { ACTION_ERROR, ActionError } from '../../pillar/common/actions/ActionError';
import { AlertsComponent } from '../../pillar/alerts/components/alerts.component';
import { GroupListModel } from '../../customer/models/GroupListModel';
import { GroupModel } from '../../customer/models/GroupModel';
import { ModuleConfiguration as GroupModuleConfiguration } from '../../customer/customer.module.config';

@Component({
  selector: 'brd-delete-submission-confirmation-dialog',
  templateUrl: './delete-submission-confirmation-dialog.component.html',
  styleUrls: ['./delete-submission-confirmation-dialog.component.scss']
})
export class DeleteSubmissionConfirmationDialogComponent implements OnInit, OnDestroy {
  eventUnsubscribe: Subscription;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  name: string;
  key: string;
  deleteActionIdentifier:string;
  @ViewChild(AlertsComponent)
  alerts: AlertsComponent;
  loading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DeleteSubmittingEntityModel>,
    private router: Router,
    private actions$: Actions,
    private submittingEntityTileStore: Store<TileState<SubmittingEntityListModel, SubmittingEntityModel>>,
    private groupTileStore: Store<TileState<GroupListModel, GroupModel>>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteSubmittingEntityModel) {
    this.name = data.name;
    this.key = data.key;
  }

  ngOnInit() {
    this.eventUnsubscribe = this.actions$.ofType(actions.deleteSuccessType<DeleteSubmittingEntityModel>(SubmissionModuleConfiguration.moduleName, DeleteSubmittingEntityModel))
      .subscribe((a: actions.DeleteSuccessAction<DeleteSubmittingEntityModel>) => {
        var inTileView = this.router.url.includes('administration');
        if (inTileView) {
          this.submittingEntityTileStore.dispatch(new actions.QueryListAction(SubmissionModuleConfiguration.moduleName,
            SubmittingEntityListModel,
            {
              page: 0,
              pageSize: 20,
            }));
          this.groupTileStore.dispatch(new actions.QueryListAction(GroupModuleConfiguration.moduleName,
            GroupListModel,
            {
              page: 0,
              pageSize: 20,
            }));
        } else {
          this.router.navigateByUrl('/administration');
        }
        this.close();
      });

    this.actions$.ofType(ACTION_ERROR)
      .filter((a: ActionError) => this.deleteActionIdentifier && a.payload.action.identifier === this.deleteActionIdentifier)
      .takeUntil(this.destroyed$)
      .subscribe((p: ActionError) => {
        for (let error in p.payload.errors) {
          if (p.payload.errors.hasOwnProperty(error)) {
            this.alerts.addError(p.payload.errors[error]);
          }
        }
      });
  }

  ngOnDestroy(): void {
    if (this.eventUnsubscribe) {
      this.eventUnsubscribe.unsubscribe();
    }
  }
  delete() {
    var model = this.data;
    var deleteAction = new actions.DeleteAction(SubmissionModuleConfiguration.moduleName, DeleteSubmittingEntityModel, { model: model });
    this.deleteActionIdentifier = deleteAction.identifier;
    this.submittingEntityTileStore.dispatch(deleteAction);
    this.loading = true;
  }

  close() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/submission/components/delete-submission-confirmation-dialog.component.ts